import { Title, Box } from "@mantine/core";

import { getProductTeeth, getTeethNumbers } from "../utils/product.utils";
import { getOrderFirstProduct } from "../utils/order.utils";

import BoxOrderView from "./BoxOrderView";
import DentalArchesSvg from "./DentalArchesSvg";
import { STYLE } from "../types/constants";
import { Order } from "../types/interfaces";
import { Product } from "../types/interfaces";

type OrderViewSelectedTeethProps = {
  order: Order;
  selectedProduct: Product;
  id: string;
};

const OrderViewSelectedTeeth = ({
  order,
  selectedProduct,
  id,
}: OrderViewSelectedTeethProps) => {
  return (
    <BoxOrderView span={5} minHeight={54} id={id}>
      <Title
        order={4}
        style={{
          color: STYLE.primary,
        }}
      >
        Selected product's teeth
      </Title>
      <Box
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "baseline",
          height: "100%",
        }}
      >
        {getProductTeeth(getOrderFirstProduct(order)) && (
          <DentalArchesSvg
            teeth={getTeethNumbers(selectedProduct as unknown as Product)}
            width={275}
            height={366}
          />
        )}
      </Box>
    </BoxOrderView>
  );
};

export default OrderViewSelectedTeeth;
